

var storredNews = sessionStorage.getItem(document.location.hostname + '-storredNewsData');
if (storredNews) {
    var storredNews = JSON.parse(storredNews);
    $('.blogsWrapper .blogs').html(storredNews);
} else {
    $.ajax({
        url: '/blog/',
        type: 'GET',
        success: function (response) {
            var content = $(response);
            var newsItems = content.find('.news-item').slice(0, 3);
            var combinedHtml = '';
            newsItems.each(function (index, element) {
                var $element = $(element);
                var $elementImage = $element.find('.image img').attr('data-src') || $element.find('.image img').attr('src');
                var $elementTitle = $element.find('.title').text().trim();
                var $elementLink = $element.find('.title').attr('href');
                var $elementDescription = $element.find('.description').html();
                combinedHtml += `
                    <div class="newsItem">
                        <div class="image">
                            <a href="${$elementLink}" class="title">
                                <img src="${$elementImage}">
                            </a>
                        </div>
                        <div class="text">
                      
                            <a href="${$elementLink}" class="title">${$elementTitle}</a>
                            <div class="description">${$elementDescription}</div>
                                <a href="${$elementLink}" class="readAll"><span>Přečíst</span></a>
                        </div>
                    </div>
                `;
            });
            $('.blogsWrapper .blogs').html(combinedHtml)
            sessionStorage.setItem(document.location.hostname + '-storredNewsData', JSON.stringify(combinedHtml));
        },
        error: function (xhr, status, error) {
            console.error("Error fetching rating data:", status, error);
        }
    }).done(function () {
    });
}




if ($('.in-blog').length) {
    $('#newsWrapper .news-item').each(function () {
        $(this).find(".description").after(`<a href="${$(this).find('a:first').attr('href')}" class="readAll"><span>Přečíst</span></a>`);

    });
}


